import React from 'react';
import { render } from 'react-dom';
import { ServiceTrack } from '@common/utils/ServiceTrack';

// 全局根组件 提前路由引入 以保证全局样式在最前
import App from './pages/App'; 

// 状态管理
import { Redux } from './common/redux';

// 路由
import { Router } from './common/router';



      
// // 功能函数
// import { getUrlQuery, saveToken } from './common/utils/token';
// import { register } from './common/utils/serviceWorker';
 
const Root = (
    <Redux>
        <Router mode="browser">
            <App />
        </Router>
    </Redux>
);

render(Root, document.getElementById('root'));

Date.prototype.Format = function(fmt) {
    var o = {
        'y+': this.getFullYear(),
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        'S+': this.getMilliseconds(), //毫秒
    };

    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            if (k == 'y+') {
                fmt = fmt.replace(RegExp.$1, ('' + o[k]).substr(4 - RegExp.$1.length));
            } else if (k == 'S+') {
                var lens = RegExp.$1.length;
                lens = lens == 1 ? 3 : lens;
                fmt = fmt.replace(RegExp.$1, ('00' + o[k]).substr(('' + o[k]).length - 1, lens));
            } else {
                fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
                );
            }
        }
    }
    return fmt;
};
